var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"hiveRoot"},[_c('we-hive-list',{attrs:{"data":_vm.data,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }